import { render } from "./Impressum.vue?vue&type=template&id=3d08427e"
import script from "./Impressum.vue?vue&type=script&lang=ts"
export * from "./Impressum.vue?vue&type=script&lang=ts"

import "./Impressum.vue?vue&type=style&index=0&id=3d08427e&lang=scss"
script.render = render

export default script